import { render, staticRenderFns } from "./UsersOption.vue?vue&type=template&id=1bb16c44&scoped=true&"
import script from "./UsersOption.vue?vue&type=script&lang=js&"
export * from "./UsersOption.vue?vue&type=script&lang=js&"
import style0 from "./UsersOption.vue?vue&type=style&index=0&id=1bb16c44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb16c44",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bb16c44')) {
      api.createRecord('1bb16c44', component.options)
    } else {
      api.reload('1bb16c44', component.options)
    }
    module.hot.accept("./UsersOption.vue?vue&type=template&id=1bb16c44&scoped=true&", function () {
      api.rerender('1bb16c44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/materialsRequests/components/UsersOption.vue"
export default component.exports